





























import { Component, Ref, Vue } from 'vue-property-decorator'
import moment from 'moment-timezone'
import DatePicker from '@/components/ui/DatePicker.vue'
import { obrigatorio } from '@/shareds/regras-de-form'
import { Voucher } from '@/models'

@Component({
	components: {
		DatePicker,
	},
})
export default class DialogoDeEdicaoDeExpiracaoDeVoucher extends Vue {
	@Ref() form!: HTMLFormElement
	obrigatorio = obrigatorio
	voucher: Voucher | null = null
	novaData: string | null = null
	mostra = false
	salvando = false

	mostrar(voucher: Voucher) {
		this.voucher = voucher
		this.novaData = moment(voucher.expiracao).format('YYYY-MM-DD')
		this.mostra = true
		setTimeout(() => {
			this.form.resetValidation()
		})
	}

	salvar() {
		if (!this.voucher || !this.novaData) return

		const horaOriginal = moment(this.voucher.expiracao).format('HH:mm:ss')
		const novaExpiracao = moment
			.tz(`${this.novaData} ${horaOriginal}`, 'America/Sao_Paulo')
			.toISOString(true)

		this.$emit('salvar', { ...this.voucher, expiracao: novaExpiracao })
	}

	saving(salvando = true) {
		this.salvando = salvando
	}

	esconder() {
		this.mostra = false
	}
}
